module.exports = __webpack_public_path__ + "static/homepage-hero-bg-799054c49ee3ddbd1017b6ff20fbb0ff.jpg";